var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";

import Edit from "./components/Edit";
import LayoutTabs from "./layouts/Tabs";
import Preview from "./components/Preview";
import Tab from "./components/Tab";
import Tabs from "./components/Tabs";
import loadEditorTheme from "./utils/loadEditorTheme";

var ReactInteractiveComponent = function (_Component) {
  _inherits(ReactInteractiveComponent, _Component);

  function ReactInteractiveComponent(props, context) {
    _classCallCheck(this, ReactInteractiveComponent);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    var originalComponent = _this.getOriginalComponent();
    _this.state = {
      enhancedProps: _extends({}, originalComponent ? originalComponent.props : {})
    };
    _this.handleControlChange = _this.handleControlChange.bind(_this);
    return _this;
  }

  ReactInteractiveComponent.prototype.handleControlChange = function handleControlChange(name, value, valid) {
    var enhancedProps = this.state.enhancedProps;

    if (valid) {
      var _extends2;

      this.setState({ enhancedProps: _extends({}, enhancedProps, (_extends2 = {}, _extends2[name] = value, _extends2)) });
    }
  };

  ReactInteractiveComponent.prototype.getOriginalComponent = function getOriginalComponent() {
    var _props = this.props,
        children = _props.children,
        component = _props.component;


    if (React.isValidElement(children)) {
      return children;
    } else if (React.isValidElement(component)) {
      return component;
    }

    return null;
  };

  ReactInteractiveComponent.prototype.renderCustomLayout = function renderCustomLayout() {
    var enhancedProps = this.state.enhancedProps;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component;

    var enhancedComponent = React.cloneElement(component, enhancedProps);
    return children(enhancedComponent, this.handleControlChange);
  };

  ReactInteractiveComponent.prototype.renderDefaultLayout = function renderDefaultLayout(originalComponent) {
    var enhancedProps = this.state.enhancedProps;
    var _props3 = this.props,
        displayName = _props3.displayName,
        hiddenProps = _props3.hiddenProps,
        tabsColor = _props3.tabsColor;

    var enhancedComponent = React.cloneElement(originalComponent, enhancedProps);
    return React.createElement(LayoutTabs, {
      displayName: displayName,
      enhancedComponent: enhancedComponent,
      onChange: this.handleControlChange,
      hiddenProps: hiddenProps,
      tabsColor: tabsColor
    });
  };

  ReactInteractiveComponent.prototype.render = function render() {
    var _props4 = this.props,
        children = _props4.children,
        component = _props4.component;

    var originalComponent = this.getOriginalComponent();

    if (typeof children === "function" && React.isValidElement(component)) {
      return this.renderCustomLayout();
    } else if (originalComponent) {
      return this.renderDefaultLayout(originalComponent);
    } else {
      // eslint-disable-next-line
      console.log(originalComponent);
    }

    return null;
  };

  return ReactInteractiveComponent;
}(Component);

ReactInteractiveComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  component: PropTypes.element,
  displayName: PropTypes.string,
  hiddenProps: PropTypes.arrayOf(PropTypes.string),
  tabsColor: PropTypes.string
} : {};

ReactInteractiveComponent.defaultProps = {
  displayName: null,
  hiddenProps: [],
  tabsColor: null
};

export { Edit, Preview, Tab, Tabs, loadEditorTheme };

export default ReactInteractiveComponent;